import Dashboard from "../pages/Dashboard/Dashboard";
import EmployeeWellness from "../pages/Wellness/Wellness";
import ManagerEmp from "../pages/PeopleDirectory/PeopleDirectory";
import ManagerCal from "../pages/OrganisationalPulse/OrganisationalPulse";
import EatwellCategory from "../pages/Wellness/EatWell/SingleCategory";
import Exercise from "../pages/Wellness/Exercise/Exercise";
import OtpVarification from "../pages/authentication/OtpVarification";
import Signup from "../pages/authentication/Signup";

import ExerciseCategory from "../pages/Wellness/Exercise/SingleCategory";
import ForgetPassword from "../pages/authentication/ForgetPassword";
import LinkSentConfirmation from "../pages/authentication/LinkSentConfirmation";

import DailyLog from "../pages/DailyMoodCapture/DailyMoodCapture";
import MoodCaptureCalendar from "../pages/MoodCaptureCalendar/MoodCaptureCalendar";
import CompanyConfigurator from "../pages/managerPages/CompanyConfigurator/CompanyConfigurator";
import EmployeeQuestionnaires from "../pages/Questionnaires/Questionnaires";

import ResetPassword from "../pages/authentication/ResetPassword";
import NotificationsView from "../pages/Notifications/Notifications";
import Login from "../pages/Login/Login";
import EatWell from "../pages/Wellness/EatWell/EatWell";
import SingleRecipe from "../pages/Wellness/EatWell/SingleRecipe";
import Mindfulness from "../pages/Wellness/Mindfulness/Mindfulness";
import VirtualCommute from "../pages/Wellness/VirtualCommute/VirtualCommute";
import SupportConnect from "../pages/Wellness/SupportConnect/SupportConnect";

import AnswerQuestionnaire from "../pages/Questionnaires/AnswerQuestionnaire";
import OrganisationQuestionnaires from "../pages/managerPages/Questionnaires/OrganisationQuestionnaires";
import OrganisationQuestionnaireResponses from "../pages/managerPages/Questionnaires/OrganisationQuestionnaireResponses";
import OrganisationCreateQuestionnaire from "../pages/managerPages/Questionnaires/OrganisationCreateQuestionnaire";
import OrganisationEditDraftQuestionnaire from "../pages/managerPages/Questionnaires/OrganisationEditDraftQuestionnaire";
import PeopleCalendar from "../pages/PeopleCalendar/PeopleCalendar";

const AuthenticationRoutes = [
  {
    path: "login",
    auth: false,
    element: <Login />,
  },
];

//Manager Routes
const ManagerRoutes = [
  {
    index: true,
    auth: true,
    path: "/organisation/pulse",
    element: <ManagerCal />,
  },
  {
    path: "/manager/questionnaires",
    element: <OrganisationQuestionnaires />,
    auth: true,
    title: "Questionnaire Configurator",
  },

  {
    path: "/manager/questionnaires/create",
    auth: true,
    element: <OrganisationCreateQuestionnaire />,
    title: "Create Questionnaire",
  },

  {
    path: "/manager/questionnaires/edit/:id",
    auth: true,
    element: <OrganisationEditDraftQuestionnaire />,
    title: "Create Questionnaire",
  },

  {
    path: "/manager/questionnaires/responses/:id",
    element: <OrganisationQuestionnaireResponses />,
    auth: true,
    title: "Questionnaire Responses",
  },

  {
    path: "/organisation/configurator",
    element: <CompanyConfigurator />,
    auth: true,
    title: "Company Configurator",
  },
  {
    path: "/organisation/people",
    element: <ManagerEmp />,
    auth: true,
    title: "People Directory",
  },
  {
    path: "/people/calendar",
    element: <PeopleCalendar />,
    auth: true,
    title: "People Calendar",
  },
];

//Employee Route
const EmployeeRoutes = [
  // Dashboard
  {
    index: true,
    path: "/dashboard",
    auth: true,
    element: <Dashboard />,
  },

  // Mood Capture Calendar
  {
    path: "/calendar/mood",
    element: <MoodCaptureCalendar />,
    auth: true,
    title: "Mood Capture Calender",
  },

  // Questionnaires
  {
    path: "/questionnaires",
    element: <EmployeeQuestionnaires />,
    auth: true,
    title: "Questionnaires | Mind Pulse",
  },
  {
    path: "/questionnaires/answer",
    auth: true,
    element: <AnswerQuestionnaire />,
    title: "Questionnaire",
  },

  {
    path: "/account/verify",
    auth: false,
    element: <OtpVarification />,
  },
  {
    path: "signup",
    auth: false,
    element: <Signup />,
  },
  {
    path: "/mood/capture",
    auth: true,
    element: <DailyLog />,
    title: "Employee Daily Log",
  },

  // Wellness Routes
  {
    path: "/wellness",
    auth: true,
    element: <EmployeeWellness />,
    title: "Wellness",
  },

  // Recipe Routes
  {
    path: "wellness/recipes",
    auth: true,
    element: <EatWell />,
    title: "Eat Well - Wellness | Mind Pulse",
  },
  {
    path: "wellness/recipes/category",
    auth: true,
    element: <EatwellCategory />,
    title: "Eat Well - Wellness | Mind Pulse",
  },
  {
    path: "/wellness/recipes/details",
    auth: true,
    element: <SingleRecipe />,
    title: "Eat Well - Wellness | Mind Pulse",
  },

  // Exercise Routes
  {
    path: "wellness/exercises",
    auth: true,
    element: <Exercise />,
    title: "Exercise Library - Wellness | Mind Pulse",
  },
  {
    path: "wellness/exercises/category",
    auth: true,
    element: <ExerciseCategory />,
    title: "Exercises - Wellness | Mind Pulse",
  },

  // Mindfulness
  {
    path: "wellness/mindfulness",
    auth: true,
    element: <Mindfulness />,
    title: "Mindfullness",
  },

  // Virtual Commute
  {
    path: "wellness/commute",
    auth: true,
    element: <VirtualCommute />,
    title: "Virtual Commute - Wellness | Mind Pulse",
  },

  // Support Connect
  {
    path: "wellness/support",
    auth: true,
    element: <SupportConnect />,
    title: "Support Connect - Wellness | Mind Pulse",
  },

  {
    path: "/account-recovery",
    auth: false,
    element: <ForgetPassword />,
  },
  {
    path: "/email-confirmation",
    auth: false,
    element: <LinkSentConfirmation />,
  },
  {
    path: "/password/reset",
    auth: false,
    element: <ResetPassword />,
    title: "Reset your Password",
  },
  {
    path: "/employee/notifications",
    auth: true,
    element: <NotificationsView />,
    title: "Notifications",
  },
];

export { AuthenticationRoutes, ManagerRoutes, EmployeeRoutes };
